import React from "react";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";

const BinDataItem = ({ value }) => {

  const {
    bin,
    country,
    countryCode,
    bank,
    paymentSystem
  } = value;

  return (
    <StyledTableRow
      scroll="auto"
      col="5"
      className="bin-data-table__row"
    >
      <StyledCol>
        {bin}
      </StyledCol>
      <StyledCol>
        {country}
      </StyledCol>
      <StyledCol>
        {countryCode}
      </StyledCol>
      <StyledCol>
        {bank}
      </StyledCol>
      <StyledCol>
        {paymentSystem}
      </StyledCol>
    </StyledTableRow>
  );
};

export default BinDataItem;